import { render, staticRenderFns } from "./OrderPayment.vue?vue&type=template&id=10b65133&scoped=true&"
import script from "./OrderPayment.vue?vue&type=script&lang=js&"
export * from "./OrderPayment.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/login.css?vue&type=style&index=0&id=10b65133&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b65133",
  null
  
)

export default component.exports